export function calculateRoundOff(total: any): { finalPrice: any; roundOff: any } {
  const rounded = Math.round(total);
  const difference = parseFloat((rounded - total)?.toFixed(2)); 
  const roundOff =difference 

  return {
    finalPrice: rounded,
    roundOff,
  };
}

